import Link from '@/components/Link';
import Container from '@/components/Container';
import client from '@/api/client';
import { materialsListingQuery } from '@/api/queries';

export async function getStaticProps() {
  const { data } = await client().query({ query: materialsListingQuery });

  return {
    props: {
      materials: data?.materials?.nodes || [],
    },
  };
}

export default function ScrumMaterialsPage({ materials }) {
  return (
    <div className="relative flex flex-col min-h-full py-10 lg:py-20">
      <Container>
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="space-y-10 lg:col-span-12 lg:space-y-14">
            <div className="space-y-4 lg:space-y-5">
              <h1 className="text-2xl font-bold tracking-tight lg:text-4xl lg:font-extrabold xl:text-5xl">
                Materiales de Scrum
              </h1>
              <div className="text-lg text-gray-600 lg:max-w-screen-md lg:text-xl">
                <p className="leading-relaxed">
                  Scrum es un marco de trabajo liviano que ayuda a las personas,
                  equipos y organizaciones a generar valor a través de
                  soluciones adaptativas para problemas complejos.
                </p>
              </div>
            </div>
            <div>
              <hr className="h-px bg-gray-200 border-none" />
            </div>
            <div>
              <div className="space-y-8 lg:space-y-10 xl:space-y-12">
                <div className="grid grid-cols-1 gap-6 md:grid-cols-12 lg:gap-6">
                  {materials.map((material) => (
                    <Link
                      key={material.id}
                      href={`/recursos${material.uri}`}
                      className="space-y-6 overflow-hidden duration-200 ease-in-out transform hover:-translate-y-2 md:col-span-4 lg:space-y-8"
                    >
                      <div className="relative overflow-hidden text-white bg-green-500 rounded-lg shadow-lg aspect-w-9 aspect-h-5 lg:rounded-xl xl:rounded-2xl">
                        <div className="absolute bottom-0 left-0 right-0 flex flex-col p-6 space-y-4 bg-gradient-to-t from-green-600 to-transparent lg:p-8">
                          <div>
                            <div className="inline-flex px-5 font-medium leading-8 text-green-800 bg-white rounded-full whitespace-nowrap lg:py-1 lg:text-sm lg:font-semibold">
                              Materiales
                            </div>
                          </div>
                          <h3 className="text-xl font-semibold lg:text-3xl lg:font-bold lg:tracking-tight">
                            {material.title}
                          </h3>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
            <div>
              <div className="p-8 bg-gray-100 rounded-lg lg:rounded-xl lg:p-10 xl:rounded-2xl">
                <div className="space-y-6 text-center lg:space-y-8 lg:p-8">
                  <h3 className="text-xl font-semibold tracking-tight lg:text-2xl xl:text-3xl">
                    ¿Buscas obtener una certificación Scrum?
                  </h3>
                  <div className="flex justify-center space-x-4">
                    <Link
                      href="/certificaciones"
                      className="inline-flex px-6 py-1 text-lg font-semibold leading-10 text-white bg-green-500 rounded-full hover:bg-green-600 focus:bg-green-600 focus:ring-4 focus:ring-green-500 focus:ring-opacity-10"
                      role="button"
                    >
                      Certifícate hoy mismo
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}
